function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#E0E0E0",
  d: "M1.75 16.75h18.5c.966 0 1.75-.784 1.75-1.75V2c0-.966-.784-1.75-1.75-1.75H1.75C.783.25 0 1.034 0 2v13c0 .966.783 1.75 1.75 1.75z"
}), React.createElement("path", {
  fill: "#D9D9D9",
  d: "M12 16.75h8.25c.966 0 1.75-.784 1.75-1.75V2c0-.966-.784-1.75-1.75-1.75H1.75C.783.25 0 1.034 0 2l12 14.75z"
}), React.createElement("path", {
  fill: "#EEE",
  d: "M2.373 16.75H20.25c.966 0 1.75-.784 1.75-1.75V2.25L2.372 16.75z"
}), React.createElement("path", {
  fill: "#E0E0E0",
  d: "M11.873 16.75h8.377c.966 0 1.75-.784 1.75-1.75V2.25L8.386 12.308l3.487 4.442z"
}), React.createElement("path", {
  fill: "#CA3737",
  d: "M20.25 1.25H1.75C.783 1.25 0 1.034 0 2v13c0 .966.783 1.75 1.75 1.75h.75V2.5h17v14.25h.75c.966 0 1.75-.784 1.75-1.75V2c0-.966-.784-.75-1.75-.75z"
}), React.createElement("path", {
  fill: "#F5F5F5",
  d: "M20.25.25H1.75C.783.25 0 1.018 0 2c0 .603.759 1.129.759 1.129L11 10.378 21.241 3.13S22 2.603 22 2c0-.982-.784-1.75-1.75-1.75z"
}), React.createElement("path", {
  fill: "#E84F4B",
  d: "M20.623.291L11 7 1.377.291C.59.46 0 1.149 0 2c0 .603.759 1.129.759 1.129L11 10.378 21.241 3.13S22 2.603 22 2c0-.851-.59-1.54-1.377-1.709z"
}));

var SvgIconGmail = function SvgIconGmail(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconGmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-gmail.acc99c0a.svg";
export { ForwardRef as ReactComponent };